import { RoleModel } from "../../factories/role/role.model";

/** Dot colors for the "My roles" chips (roles have no color of their own). */
export const ROLE_DOT_COLORS = [
  "#6B4EFF",
  "#0EA5E9",
  "#16A34A",
  "#F59E0B",
  "#EC4899",
  "#14B8A6",
  "#EF4444",
  "#8B5CF6",
];

/** The roles the signed-in user belongs to, A–Z, each with a dot color. */
export const myRoles = (
  roles: RoleModel[] | undefined,
  userId: string | undefined,
) =>
  (roles ?? [])
    .filter(
      (role) =>
        !!userId &&
        role.isActive !== false &&
        (role.userRoles ?? []).some(
          (member) => member.userId?.toLowerCase() === userId.toLowerCase(),
        ),
    )
    .sort((a, b) => a.roleName.localeCompare(b.roleName))
    .map((role, index) => ({
      id: role.id,
      name: role.roleName,
      color: ROLE_DOT_COLORS[index % ROLE_DOT_COLORS.length],
    }));
